var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/logo.png"),"alt":_vm.logoAlt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }